"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _isUndefined = _interopRequireDefault(require("lodash/isUndefined"));

var _reactDom = _interopRequireDefault(require("react-dom"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _DarkDropdownPopup = _interopRequireDefault(require("./DarkDropdownPopup"));

var _DropdownItem = _interopRequireDefault(require("./DropdownItem"));

var DarkDropdown =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(DarkDropdown, _PureComponent);

  function DarkDropdown(props) {
    var _this;

    (0, _classCallCheck2.default)(this, DarkDropdown);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(DarkDropdown).call(this, props));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "handleOutsideClick", function (_ref) {
      var target = _ref.target;
      if (_this.state.wrapNode.contains(target) || _this.popupNode.contains(target)) return;
      var _this$props = _this.props,
          open = _this$props.open,
          onOpenStateChange = _this$props.onOpenStateChange;

      if (open) {
        onOpenStateChange && onOpenStateChange();
      } else {
        _this.close();
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "handleClick", function (e) {
      var target = e.target;

      if (_this.props.stopPropagation) {
        e.stopPropagation();
      }

      if (_this.popupNode.contains(target)) return;

      if (_this.state.wrapNode.firstChild.contains(target)) {
        _this.setState({
          showPopup: !_this.state.showPopup
        });

        _this.props.onVisibleStateChange && _this.props.onVisibleStateChange(!_this.state.showPopup);
      } else {
        _this.close();
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "close", function () {
      if (_this.state.showPopup) {
        _this.props.onVisibleStateChange && _this.props.onVisibleStateChange(false);

        if (_this.state.showPopup && !_reactDom.default.createPortal) {
          _this.popupNode.removeChild(_this.popupNode.firstChild);
        }

        _this.setState({
          showPopup: false
        });
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "setRef", function (node) {
      _this.setState({
        wrapNode: node
      });
    });
    _this.state = {
      showPopup: _this.props.open || false
    };
    var _this$props2 = _this.props,
        popupWrapperZIndex = _this$props2.popupWrapperZIndex,
        parentNode = _this$props2.parentNode;
    _this.popupNode = document.createElement('div');
    _this.popupNode.style = 'position: absolute; top: 0px; left: 0px;z-index: ' + popupWrapperZIndex + ';';
    parentNode.appendChild(_this.popupNode);
    document.addEventListener('click', _this.handleOutsideClick);
    return _this;
  }

  (0, _createClass2.default)(DarkDropdown, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.popupNode.parentNode.removeChild(this.popupNode);
      document.removeEventListener('click', this.handleOutsideClick);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          children = _this$props3.children,
          overlay = _this$props3.overlay,
          placement = _this$props3.placement,
          popupWrapperClassName = _this$props3.popupWrapperClassName,
          popupWidth = _this$props3.popupWidth,
          popupCustomStyle = _this$props3.popupCustomStyle,
          parentNode = _this$props3.parentNode;
      var showPopup = this.state.showPopup;
      return _react.default.createElement("div", {
        onClick: this.handleClick,
        ref: this.setRef,
        role: "button",
        tabIndex: "0"
      }, children, _react.default.createElement(_DarkDropdownPopup.default, {
        popupNode: this.popupNode,
        content: overlay,
        close: this.close,
        popupWrapperClassName: popupWrapperClassName,
        popupWidth: popupWidth,
        wrapNode: this.state.wrapNode,
        placement: placement,
        showPopup: showPopup,
        popupCustomStyle: popupCustomStyle,
        parentNode: parentNode
      }));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props) {
      if (!(0, _isUndefined.default)(props.open)) {
        return {
          showPopup: props.open
        };
      }

      return false;
    }
  }]);
  return DarkDropdown;
}(_react.PureComponent);

DarkDropdown.defaultProps = {
  placement: 'bottomLeft',
  onVisibleStateChange: null,
  popupWrapperClassName: null,
  popupWidth: null,
  stopPropagation: false,
  popupCustomStyle: {},
  parentNode: document.body
};
DarkDropdown.propTypes = {
  overlay: _propTypes.default.oneOfType([_propTypes.default.node, _propTypes.default.func]).isRequired,
  popupWrapperClassName: _propTypes.default.string,
  popupWidth: _propTypes.default.number,
  placement: _propTypes.default.oneOf(['bottomLeft', 'bottomRight']),
  onVisibleStateChange: _propTypes.default.func,
  stopPropagation: _propTypes.default.bool,
  popupCustomStyle: _propTypes.default.object,
  parentNode: _propTypes.default.instanceOf(Element)
};
DarkDropdown.Item = _DropdownItem.default;
var _default = DarkDropdown;
exports.default = _default;